import { Grid, Typography } from "@mui/material";
import MainTitle from "../muiHome/mainTitle";
const CSEBTechLab=()=>{

return (
<Grid container spacing={2}>
<Grid item xs={12}>
    <MainTitle title="Laboratories" />
    </Grid>

    

    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    <strong>Empowering future healthcare professionals through excellence in Allied Health education, research, and clinical training  </strong> <br/><br/>
 The School of Allied Health Sciences at MVN University, Palwal is a center of excellence dedicated to developing skilled and compassionate healthcare professionals. Our advanced laboratories and practical training facilities are thoughtfully designed to support hands-on learning, research, and clinical skill development across a wide range of allied health disciplines, including DMLT, BMLT, MMLT, Bachelor of Physiotherapy (BPT), B.Sc in Biotechnology and B.Sc in Cardiovascular Technology (B.Sc CVT). <br/><br/>
 <strong> Laboratory Highlights </strong>  <br/> <br/>
Our laboratories are equipped with modern instruments and technologies that align with current academic and healthcare industry standards. These facilities provide students with immersive, real-world experience in areas such as medical laboratory technology, microbiology, biotechnology, anatomy, physiology, and practicals related to DMLT, BMLT, MMLT, BPT and B.Sc in Biotechnology and CVT programs. The structured practical sessions enhance understanding of theoretical knowledge through experiential learning and clinical simulations.

<br/><br/>
<strong> Salient Features </strong>  <br/> <br/>

<ul class="details_list">
    <li>	State-of-the-art labs for practical and clinical training</li>
    <li>	Regular maintenance and equipment calibration</li>
    <li>	Emphasis on safety standards and Good Laboratory Practices (GLP)</li>
    <li>	Hands-on, industry-relevant training modules</li>
    <li>	Integration of digital tools and simulation-based learning</li>
    <li>	Dedicated practical schedules for BPT and B.Sc CVT to ensure skill mastery</li>
     
</ul>

<br/> <br/>

    </Typography>
    </Grid>
    </Grid>

)
}
export default CSEBTechLab;